'use client';
import { useIsomorphicLayoutEffect } from '@repo/common-utils';
import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';

import { BznavAppVersion } from '../types';
import { sendBznavNativeMessage } from '../utils/react-native-bridge';

import { useWorkingPlatform } from './use-working-platform';

export const bznavAppVersionAtom = atom<BznavAppVersion>();

export const useBznavAppVersion = () => {
  const [bznavAppVersion, setBznavAppVersion] = useAtom(bznavAppVersionAtom);
  const { workingPlatform } = useWorkingPlatform();

  const getAppVersion = useCallback(() => {
    if (workingPlatform !== 'app' || bznavAppVersion) return;

    try {
      sendBznavNativeMessage(
        'getAppVersion',
        {},
        (response: unknown) => {
          if (response) {
            setBznavAppVersion(response as BznavAppVersion);
          }
        },
        5000
      );
    } catch (error) {
      console.error('Failed to retrieve app version from native bridge in getAppVersion:', error);
      setBznavAppVersion(undefined);
    }
  }, [bznavAppVersion, setBznavAppVersion, workingPlatform]);

  useIsomorphicLayoutEffect(() => {
    getAppVersion();
  }, [getAppVersion]);

  return { bznavAppVersion };
};
